import { init as SentryInit } from '@sentry/react';

if (__SITE_CONTEXT__.data.sentryEnabled && __SITE_CONTEXT__.data.sentryDsn) {
  SentryInit({
    dsn: __SITE_CONTEXT__.data.sentryDsn,
    environment: __SITE_CONTEXT__.data.sentryEnvironment,
    release: __SITE_CONTEXT__.data.sentryRelease,
    tunnel: '/api/sentry/tunnel',
    beforeSend(event) {
      event.server_name = 'mio-web-browser';
      return event;
    },
  });
}

if (__SITE_CONTEXT__.data.publicPath) {
  __webpack_public_path__ = __SITE_CONTEXT__.data.publicPath;
}

import React from 'react';
import { hydrate } from 'react-dom';
import Layout from './components-legacy/Layout';
import PreviewProvider from './preview/PreviewProvider';
import Site from './SiteContext';
import componentLoaderAccessor from './utils/componentLoader';
import initBodyScrollTracking from './tracking/bodyScroll';
import initTracking from './tracking/dataLayer';
import initTriggerbee from './tracking/triggerbee';
import ourInsights from './tracking/ourInsights';

const componentLoader = componentLoaderAccessor();

Promise.all(__SITE_CONTEXT__.preload.map((m) => componentLoader.load(m))).then(() => {
  initTracking();
  initTriggerbee();
  initBodyScrollTracking();

  ourInsights(__SITE_CONTEXT__.data.ourInsightsCollector, __SITE_CONTEXT__.data.experiments);

  const targetNode = document.getElementById('app');
  hydrate(
    <PreviewProvider isPreview={__SITE_CONTEXT__.data.isPreview}>
      <Site siteContext={__SITE_CONTEXT__}>
        <Layout />
      </Site>
    </PreviewProvider>,
    targetNode,
  );
});
